var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 744,
    height: 1229,
    viewBox: "0 0 744 1229",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_638_478)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 744,
    height: 1229,
    fill: "#F6F4F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M809 650C783 657 726.12 662.91 675.821 662.91C615.77 662.91 484.568 591.343 500.469 447.34C516.371 303.338 662.647 433.926 726.12 494.431C758.5 525.297 827.9 561.6 819.5 572",
    stroke: "#A8EF12",
    strokeWidth: 30.0373
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9239 -18.4467C151.73 -35.3225 405.614 -67.2956 324.411 52.9094C243.208 173.115 44.4248 168.736 -20.5312 137.384",
    stroke: "#A8EF12",
    strokeWidth: 30.0373
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.462 714.481C172.327 714.24 132.259 731.622 127.699 684.799C124.032 647.135 208.132 609.016 162.572 568.147C95.0069 507.539 -16.6863 779.594 -81.3781 684.799C-130.818 612.354 29.9513 603.152 16.2381 563.546C-0.967728 513.853 -81.3781 577.53 -96.5348 551.637C-123.047 506.345 71.1483 486.622 156.856 386.389L277.832 256",
    stroke: "#A8EF12",
    strokeWidth: 30.0373
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.794 -146.091C561.406 -101.758 516.251 66.3794 651.853 56.1852C749.611 48.836 829.069 14.1931 821.496 -86.5276L814.882 -139.111",
    stroke: "#A8EF12",
    strokeWidth: 30.0373
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_638_478"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 744,
    height: 1229,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgMobile);
export default __webpack_public_path__ + "static/media/bg-mobile.28c61c39333efaeb5d5712bb1b08eba5.svg";
export { ForwardRef as ReactComponent };